import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tab from 'bootstrap/js/dist/tab';

onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});


import * as fadeIn from './scripts/fade-in';
fadeIn.init();


import * as centerActive from './scripts/center-active-tab';
centerActive.init();

import * as liveInfoScrollDown from './scripts/live-info-scroll-down';
liveInfoScrollDown.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as allyScroll from './scripts/ally-scroll';
allyScroll.init();